(() => {
  const normalize = (value) => (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const initMenu = () => {
    const button = document.querySelector('[data-hq-menu-button]');
    const menu = document.querySelector('[data-hq-mobile-menu]');
    const desktopCatalog = document.querySelector('.hq-nav-catalog');
    if (!button || !menu) return;

    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('hq-menu-open', !isOpen);
    });

    menu.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        menu.querySelectorAll('details[open]').forEach((item) => {
          if (item !== details) item.open = false;
        });
      });
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.classList.remove('hq-menu-open');
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (desktopCatalog?.open && !desktopCatalog.contains(event.target)) desktopCatalog.open = false;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (desktopCatalog?.open) desktopCatalog.open = false;
      if (!menu.hidden) {
        button.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        document.body.classList.remove('hq-menu-open');
        button.focus();
      }
    });
  };

  const initCatalog = () => {
    const grid = document.querySelector('[data-hq-product-grid]');
    if (!grid) return;

    const cards = [...grid.querySelectorAll('[data-hq-product]')];
    const search = document.querySelector('[data-hq-catalog-search]');
    const heroSearch = document.querySelector('[data-hq-search]');
    const filterButtons = [...document.querySelectorAll('[data-hq-filter]')];
    const queryButtons = [...document.querySelectorAll('[data-hq-query]')];
    const availabilitySelect = document.querySelector('[data-hq-availability]');
    const sortSelect = document.querySelector('[data-hq-sort]');
    const count = document.querySelector('[data-hq-result-count]');
    const noResults = document.querySelector('[data-hq-no-results]');
    const clearButtons = [...document.querySelectorAll('[data-hq-clear]')];
    let activeFilter = 'all';

    const applyFilters = () => {
      const query = normalize(search?.value);
      const words = query.split(/\s+/).filter(Boolean);
      const activeAvailability = availabilitySelect?.value || 'all';
      let visible = 0;

      cards.forEach((card) => {
        const text = normalize(card.dataset.search);
        const collections = normalize(card.dataset.collections);
        const availability = card.dataset.availability || 'available';
        const queryMatch = !words.length || words.every((word) => text.includes(word));
        const categoryMatch = activeFilter === 'all' || collections.includes(normalize(activeFilter));
        const availabilityMatch = activeAvailability === 'all'
          || (activeAvailability === 'available' && availability !== 'out')
          || availability === activeAvailability;
        const show = queryMatch && categoryMatch && availabilityMatch;
        card.hidden = !show;
        if (show) visible += 1;
      });

      const sort = sortSelect?.value || 'curated';
      const sortedCards = [...cards].sort((a, b) => {
        if (sort === 'title') return (a.dataset.title || '').localeCompare(b.dataset.title || '', 'es');
        if (sort === 'price-asc') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
        if (sort === 'price-desc') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
        if (sort === 'stock') return Number(b.dataset.inventory || 0) - Number(a.dataset.inventory || 0);
        return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
      });
      sortedCards.forEach((card) => grid.appendChild(card));

      if (count) count.textContent = String(visible).padStart(2, '0');
      if (noResults) noResults.hidden = visible !== 0 || cards.length === 0;
    };

    search?.addEventListener('input', applyFilters);
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.hqFilter || 'all';
        filterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        applyFilters();
      });
    });
    queryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.dataset.hqQuery || '';
        if (heroSearch) heroSearch.value = value;
        if (search) {
          search.value = value;
          document.querySelector('#catalogo')?.scrollIntoView({ behavior: 'smooth' });
          search.focus({ preventScroll: true });
          applyFilters();
        }
      });
    });
    availabilitySelect?.addEventListener('change', applyFilters);
    sortSelect?.addEventListener('change', applyFilters);
    clearButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (search) search.value = '';
        if (heroSearch) heroSearch.value = '';
        if (availabilitySelect) availabilitySelect.value = 'all';
        if (sortSelect) sortSelect.value = 'curated';
        activeFilter = 'all';
        filterButtons.forEach((item) => item.classList.toggle('is-active', item.dataset.hqFilter === 'all'));
        applyFilters();
      });
    });

    document.addEventListener('keydown', (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k' && search) {
        event.preventDefault();
        search.focus();
        search.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    applyFilters();
  };

  const initAmbientMotion = () => {
    const hero = document.querySelector('.hq-memory-hero');
    if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    hero.addEventListener('pointermove', (event) => {
      const rect = hero.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
      hero.style.setProperty('--hq-pointer-x', x.toFixed(3));
      hero.style.setProperty('--hq-pointer-y', y.toFixed(3));
    });

    hero.addEventListener('pointerleave', () => {
      hero.style.setProperty('--hq-pointer-x', '0');
      hero.style.setProperty('--hq-pointer-y', '0');
    });
  };

  const copyText = async (value) => {
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch (_error) {
        // Chrome can deny clipboard access even on HTTPS. Use the selection fallback below.
      }
    }
    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.setAttribute('aria-hidden', 'true');
    field.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;pointer-events:none';
    document.body.appendChild(field);
    field.focus({ preventScroll: true });
    field.select();
    field.setSelectionRange(0, field.value.length);
    const copied = document.execCommand('copy');
    field.remove();
    return copied;
  };

  const flashButton = (button, label) => {
    if (!button) return;
    const original = button.textContent;
    button.textContent = label;
    window.setTimeout(() => { button.textContent = original; }, 1600);
  };

  const initCatalogGenerator = () => {
    const root = document.querySelector('[data-hq-catalog-generator]');
    if (!root || root.dataset.hqGeneratorReady === 'true') return;
    root.dataset.hqGeneratorReady = 'true';

    document.body.classList.add('hq-generator-mode');
    const collection = root.querySelector('[data-hq-generator-collection]');
    const advisor = root.querySelector('[data-hq-generator-advisor]');
    const phone = root.querySelector('[data-hq-generator-phone]');
    const stock = root.querySelector('[data-hq-generator-stock]');
    const generateButton = root.querySelector('[data-hq-generate-link]');
    const result = root.querySelector('[data-hq-generator-result]');
    const outputLink = root.querySelector('[data-hq-generator-link]');
    const previewLink = root.querySelector('[data-hq-preview-catalog]');
    const copyButton = root.querySelector('[data-hq-copy-catalog-link]');
    const shareButton = root.querySelector('[data-hq-share-catalog-link]');
    let generatedUrl = '';

    try {
      advisor.value = window.localStorage.getItem('hq-catalog-advisor') || '';
      phone.value = window.localStorage.getItem('hq-catalog-phone') || '';
    } catch (_error) {
      // Private browsing can disable local storage; link generation still works.
    }

    const generate = () => {
      const targetPath = collection?.value || '/collections/all';
      const target = new URL(targetPath, window.location.origin);
      target.searchParams.set('catalogo', '1');
      target.searchParams.set('stock', stock?.checked ? '1' : '0');
      if (advisor?.value.trim()) target.searchParams.set('asesor', advisor.value.trim());
      const cleanPhone = (phone?.value || '').replace(/\D/g, '');
      if (cleanPhone) target.searchParams.set('wa', cleanPhone);
      target.hash = 'catalogo';
      generatedUrl = target.toString();

      if (outputLink) {
        outputLink.href = generatedUrl;
        outputLink.textContent = generatedUrl;
      }
      if (previewLink) previewLink.href = generatedUrl;
      if (result) {
        result.hidden = false;
        result.classList.remove('is-ready');
        window.requestAnimationFrame(() => result.classList.add('is-ready'));
      }
      try {
        window.localStorage.setItem('hq-catalog-advisor', advisor?.value.trim() || '');
        window.localStorage.setItem('hq-catalog-phone', cleanPhone);
      } catch (_error) {
        // The generated URL is already available even if storage is blocked.
      }
      result?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    generateButton?.addEventListener('click', (event) => {
      event.preventDefault();
      generate();
    });
    copyButton?.addEventListener('click', async () => {
      if (!generatedUrl) generate();
      const copied = await copyText(generatedUrl);
      flashButton(copyButton, copied ? 'COPIADO ✓' : 'SELECCIONA EL ENLACE');
    });
    shareButton?.addEventListener('click', async () => {
      if (!generatedUrl) generate();
      if (navigator.share) {
        try {
          await navigator.share({ title: 'Catálogo La Huaca Quilla', text: 'Mira esta selección disponible:', url: generatedUrl });
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }
      const copied = await copyText(generatedUrl);
      flashButton(shareButton, copied ? 'ENLACE COPIADO ✓' : 'USA COPIAR ENLACE');
    });
  };

  const initProductVariantMedia = () => {
    document.querySelectorAll('[data-hq-product-variant-media]').forEach((root) => {
      const picker = root.querySelector('variant-selects');
      const mapNode = root.querySelector('[data-hq-variant-media-map]')
        || (root.nextElementSibling?.matches('[data-hq-variant-media-map]') ? root.nextElementSibling : null);
      if (!picker || !mapNode) return;

      let variants = [];
      try {
        variants = JSON.parse(mapNode.textContent || '[]');
      } catch (_error) {
        return;
      }

      const selectedValues = () => {
        const values = [];
        picker.querySelectorAll('fieldset').forEach((fieldset) => {
          const selected = fieldset.querySelector('input[type="radio"]:checked');
          if (selected) values.push(selected.value);
        });
        picker.querySelectorAll('select').forEach((select) => values.push(select.value));
        return values;
      };

      const syncMedia = () => {
        const values = selectedValues();
        const variant = variants.find((item) => item.options.length === values.length
          && item.options.every((value, index) => normalize(value) === normalize(values[index])));
        if (!variant) return;

        const gallery = root.querySelector('media-gallery');
        const galleryTarget = variant.media
          ? [...root.querySelectorAll('.product__media-list [data-media-id]')].find((item) => item.dataset.mediaId === variant.media)
          : null;

        if (galleryTarget && gallery && typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(variant.media, true);
        } else if (variant.image) {
          const activeItem = root.querySelector('.product__media-list [data-media-id].is-active')
            || root.querySelector('.product__media-list [data-media-id]');
          const image = activeItem?.querySelector('img');
          if (image) {
            image.src = variant.image;
            image.srcset = variant.srcset || '';
            if (variant.alt) image.alt = variant.alt;
            const zoomLink = image.closest('a');
            if (zoomLink) zoomLink.href = variant.zoom || variant.image;
          }
        }

        root.dataset.hqActiveVariant = String(variant.id);
      };

      if (picker.dataset.hqVariantMediaReady !== 'true') {
        picker.dataset.hqVariantMediaReady = 'true';
        picker.addEventListener('change', () => window.requestAnimationFrame(syncMedia));
      }
      syncMedia();
    });
  };

  const initSharedCatalog = () => {
    const root = document.querySelector('[data-hq-shared-catalog]');
    const params = new URLSearchParams(window.location.search);
    if (!root || params.get('catalogo') !== '1' || root.dataset.hqSharedReady === 'true') return;
    root.dataset.hqSharedReady = 'true';

    document.body.classList.add('hq-catalog-mode');
    root.hidden = false;
    document.querySelectorAll('[data-hq-standard-collection]').forEach((element) => { element.hidden = true; });

    const collectionTitle = root.dataset.collectionTitle || 'productos';
    const advisor = params.get('asesor') || '';
    const phone = (params.get('wa') || '').replace(/\D/g, '');
    const onlyAvailable = params.get('stock') !== '0';
    const cards = [...root.querySelectorAll('[data-hq-shared-card]')];
    const search = root.querySelector('[data-hq-shared-search]');
    const resultCount = root.querySelector('[data-hq-shared-count]');
    const stockLabel = root.querySelector('[data-hq-stock-filter-label]');
    const advisorLabel = root.querySelector('[data-hq-advisor-label]');
    const advisorName = root.querySelector('[data-hq-advisor-name]');
    const noResults = root.querySelector('[data-hq-shared-no-results]');
    const tray = root.querySelector('[data-hq-selection-tray]');
    const selectionCount = root.querySelector('[data-hq-selection-count]');
    const sendButton = root.querySelector('[data-hq-send-selection]');
    const copyButton = root.querySelector('[data-hq-copy-selection]');
    const selectedCards = new Set();

    if (advisorLabel && advisor) advisorLabel.textContent = 'TU ASESOR EN LA HUACA QUILLA';
    if (advisorName && advisor) advisorName.textContent = advisor;
    if (stockLabel) stockLabel.textContent = onlyAvailable ? 'SOLO DISPONIBLES' : 'INCLUYE AGOTADOS';

    const applySharedFilters = () => {
      const words = normalize(search?.value).split(/\s+/).filter(Boolean);
      let visible = 0;
      cards.forEach((card) => {
        const matchesSearch = !words.length || words.every((word) => normalize(card.dataset.search).includes(word));
        const matchesStock = !onlyAvailable || card.dataset.productAvailable === 'true';
        const show = matchesSearch && matchesStock;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (resultCount) resultCount.textContent = String(visible).padStart(2, '0');
      if (noResults) noResults.hidden = visible !== 0 || cards.length === 0;
    };

    const updateTray = () => {
      if (selectionCount) selectionCount.textContent = String(selectedCards.size).padStart(2, '0');
      if (tray) tray.hidden = selectedCards.size === 0;
    };

    cards.forEach((card) => {
      const toggle = card.querySelector('[data-hq-add-selection]');
      toggle?.addEventListener('click', (event) => {
        event.preventDefault();
        const isSelected = selectedCards.has(card);
        if (isSelected) selectedCards.delete(card);
        else selectedCards.add(card);
        card.classList.toggle('is-selected', !isSelected);
        toggle.setAttribute('aria-pressed', String(!isSelected));
        toggle.innerHTML = isSelected ? '<span>+</span> SELECCIONAR' : '<span>✓</span> SELECCIONADO';
        updateTray();
      });

      const variantSelect = card.querySelector('[data-hq-card-variant]');
      const cardImage = card.querySelector('.hq-shared-card__media img');
      const colorChoices = [...card.querySelectorAll('[data-hq-color-choice]')];
      const syncColorChoices = () => {
        if (!variantSelect) return;
        colorChoices.forEach((choice) => {
          const isActive = choice.dataset.variantId === variantSelect.value;
          choice.classList.toggle('is-active', isActive);
          choice.setAttribute('aria-pressed', String(isActive));
        });
      };
      if (variantSelect) variantSelect.addEventListener('change', () => {
        const selected = variantSelect.selectedOptions?.[0];
        if (selected?.dataset.image && cardImage) {
          cardImage.src = selected.dataset.image;
          cardImage.srcset = '';
          if (selected.dataset.imageAlt) cardImage.alt = selected.dataset.imageAlt;
        }
        syncColorChoices();
      });
      colorChoices.forEach((choice) => {
        choice.addEventListener('click', () => {
          if (!variantSelect || choice.disabled) return;
          variantSelect.value = choice.dataset.variantId || '';
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      syncColorChoices();
    });

    const buildSelection = () => {
      const intro = advisor
        ? `Hola ${advisor}, vi el catálogo de ${collectionTitle} y seleccioné:`
        : `Hola, vi el catálogo de ${collectionTitle} y seleccioné:`;
      const lines = [...selectedCards].map((card) => {
        const variant = card.querySelector('[data-hq-card-variant]')?.selectedOptions?.[0];
        const variantTitle = variant?.dataset.title && variant.dataset.title !== 'Default Title' ? ` · ${variant.dataset.title}` : '';
        const sku = variant?.dataset.sku || card.dataset.productReference || '';
        return `• ${card.dataset.productTitle}${variantTitle} — Ref. ${sku}`;
      });
      return [intro, '', ...lines, '', 'Quiero confirmar disponibilidad y continuar la compra por este chat.'].join('\n');
    };

    sendButton?.addEventListener('click', () => {
      if (!selectedCards.size) return;
      const message = buildSelection();
      const destination = phone
        ? `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
        : `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(destination, '_blank', 'noopener');
    });

    copyButton?.addEventListener('click', async () => {
      if (!selectedCards.size) return;
      await copyText(buildSelection());
      flashButton(copyButton, 'RESUMEN COPIADO ✓');
    });
    search?.addEventListener('input', applySharedFilters);
    root.querySelector('[data-hq-clear-shared-search]')?.addEventListener('click', () => {
      if (search) search.value = '';
      applySharedFilters();
      search?.focus();
    });

    applySharedFilters();
    updateTray();
  };

  const initReveal = () => {
    const elements = document.querySelectorAll('[data-hq-reveal]');
    if (!elements.length || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    elements.forEach((element) => observer.observe(element));
  };

  const init = () => {
    document.documentElement.classList.add('hq-ready');
    initMenu();
    initCatalog();
    initCatalogGenerator();
    initProductVariantMedia();
    initSharedCatalog();
    initReveal();
    initAmbientMotion();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', () => {
    initCatalogGenerator();
    initProductVariantMedia();
    initSharedCatalog();
  });
})();
